import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import EventTileEntity from "../EventTileEntity";

class EnkindledHouseholdBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.FIREFEST;

	public static readonly frameName = FrameName.ENKINDLED_HOUSEHOLD;
}

export default EnkindledHouseholdBuildingTileEntity;
